import { MicrosoftSSOButton } from '@/components/Views/Login/MicrosoftSSOButton/MicrosoftSSOButton';
import { OrLine } from '@/components/Elements/OrLine/OrLine';
import { EmailPasswordForm } from '@/components/Views/Login/EmailPasswordForm/EmailPasswordForm';
import { LinkButton } from '@/components/Elements/LinkButton/LinkButton';
import { useTranslation } from 'react-i18next';

type SSOAndEmailPasswordLoginProps = {
  email: string;
  submitting: boolean;
  handleEmailPasswordSignin: (email: string, password: string) => void;
  handleSSOLogin: () => void;
  restartSigninProcess: () => void;
};

export const SSOAndEmailPasswordLogin = ({
  email,
  submitting,
  handleEmailPasswordSignin,
  handleSSOLogin,
  restartSigninProcess,
}: SSOAndEmailPasswordLoginProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <MicrosoftSSOButton onClick={handleSSOLogin} />
      <OrLine />
      <EmailPasswordForm
        email={email}
        submitting={submitting}
        handleSignIn={handleEmailPasswordSignin}
      />
      <OrLine />
      <LinkButton
        text={t('login.restartSignin')}
        onClick={restartSigninProcess}
      />
    </div>
  );
};
